import React from 'react';

const PricingPage = () => {
    return (
        <div className="min-h-screen py-12">
            <div className="container mx-auto px-4">
                <h1 className="text-3xl font-bold mb-6">價格方案</h1>
                <p className="text-lg">這裡將展示系統的價格方案（尚在開發中）...</p>
            </div>
        </div>
    );
};

export default PricingPage;